import { render, staticRenderFns } from "./EditClientRecordCategory.vue?vue&type=template&id=4c94d422&scoped=true"
import script from "./EditClientRecordCategory.vue?vue&type=script&lang=js"
export * from "./EditClientRecordCategory.vue?vue&type=script&lang=js"
import style0 from "./EditClientRecordCategory.vue?vue&type=style&index=0&id=4c94d422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c94d422",
  null
  
)

export default component.exports